export default "__VITE_ASSET__BVf8eDpd__"